import '../../../styles/divider.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Storage from 'utilities/storage';
import cryptoJS from 'crypto-js';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import initialActions from 'actions/initialActions';
import promotionalCodeAction from 'actions/promotionalCodeAction';
import TitleBox from 'components/commons/titleBox/titleBox';
import CheckBox from 'components/checkBox/checkBox';
import InformationCard from 'components/commons/informationCard/informationCard';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { ItemTelephone } from 'components/changeDataAC/telephone/itemTelephone';
import { ItemEmail } from 'components/changeDataAC/email/itemEmail';
import { ItemAddress } from 'components/changeDataAC/address/itemAddress';
import { FormattedText, formatText } from 'core/i18n';
import { recordEvent, recordEventStepSuccess } from 'utilities/uTagging';
import { isMobile } from 'utilities/browser';
import { LOGIN_DESKTOP, LOGIN_MOBILE, PAGE_PRODUCT, PATH_CONTACT, PUBLICA_URL } from 'constants/index';
import { ERROR_AL_VERIFICAR_CLIENTE, ERROR_AL_ENVIAR_DATOS_PERSONALES } from 'constants/analyticsErrors';
import AppliedPromoCode from 'components/promotionalCode/appliedPromoCode';
import preLoaderActions from 'actions/preLoaderActions';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { AUTHORIZED, COOWNER, REPRESENTATIVE } from 'constants/jointHolders/holderTypes';
import { getIsCoOwner } from 'utilities/jointHolders/holderTypes';

class ProfileStepClient1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            onSubmit: { disabled: 'disabled' },
            showPromoCode: false,
            cancel: false,
            telefono: true,
            email: true,
            domicilio: true,
        };

        this.gotoNextStep = this.gotoNextStep.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.formattedIban = this.formattedIban.bind(this);
        this.buildPromoCode = this.buildPromoCode.bind(this);
        this.onHandleContinue = this.onHandleContinue.bind(this);
        this.onhandleSubmit = this.onhandleSubmit.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.changeStyles = this.changeStyles.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile, promotionalCode, formActions } = this.props;

        if (typeof userProfile.clientAcceptTerms !== 'undefined') {
            const status = userProfile.clientAcceptTerms ? { onSubmit: {} } : { onSubmit: { disabled: 'disabled' } };
            this.setState(status);
        }

        if (!userProfile.accessToken && Storage.cookies.get('accessToken')) {
            formActions.change('userProfile.accessToken', Storage.cookies.get('accessToken'));
        }

        if (!userProfile.refreshToken && Storage.cookies.get('refreshToken')) {
            formActions.change('userProfile.refreshToken', Storage.cookies.get('refreshToken'));
        }

        const promoCode = promotionalCode.get('promotionalCode');
        if (promoCode.size > 0) {
            this.setState({
                showPromoCode: true,
            });
        }
    }

    gotoNextStep() {
        const { immStepsState, actions } = this.props;
        const currentIndex = immStepsState.get('currentStep');

        actions.finalizeStep({
            index: currentIndex,
            finished: true,
        });
        actions.enableFinishedAndNextStep();
        actions.changeCurrentStep({
            index: currentIndex + 1,
        });
        this.props.preLoaderActions.hidePreLoader();
    }

    onHandleContinue() {
        const { userProfile, actions, initialActions, promotionalCode, goToErrorsView } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken ? userProfile.accessToken : Storage.cookies.get('accessToken');
        const promoUrl = promotionalCode?.get('promotionalCode').get('url');

        actions.clientVerifyOk(accessToken, (verifiedOk, errors) => {
            this.props.preLoaderActions.showPreLoader();
            if (verifiedOk) {
                recordEvent(
                    PATH_CONTACT,
                    PAGE_PRODUCT,
                    'completa tus datos generales',
                    'completa tus datos generales correcto',
                    userProfile.recordId,
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );

                recordEventStepSuccess(
                    userProfile.investmentType,
                    '/onboarding/completa-tus-datos-generales',
                    'completa tus datos personales'
                );
                if (userProfile.isAlreadyClient) {
                    initialActions.precontractualProcess(
                        userProfile.onboardingType,
                        userProfile.jointHolderData?.invite.openDebitCard,
                        promoUrl,
                        this.gotoNextStep,
                        null
                    );
                } else {
                    this.gotoNextStep();
                }
            } else if (errors['6002']) {
                goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_VERIFICAR_CLIENTE });
            }
        });
    }

    buildCheckboxLabel() {
        const { products } = this.props;
        const productsInfo = products.get('products');
        let checkBoxLabel;
        let i = 0;

        productsInfo.forEach(function (value) {
            if (i === 0) {
                checkBoxLabel = `<a href=${value.url} target="_blank" class="a-blue"> ${formatText(
                    'clientJointHolder-precontractualInformation'
                )}${value.description} </a>`;
            } else if (i === productsInfo.length - 1) {
                checkBoxLabel = `${checkBoxLabel + formatText('clientJointHolder-and')} <a href=${
                    value.url
                } target="_blank" class="a-blue"> ${formatText('clientJointHolder-precontractualInformation')}${
                    value.description
                } </a>`;
            } else {
                checkBoxLabel = `${checkBoxLabel}, <a href=${value.url} target="_blank" class="a-blue"> ${formatText(
                    'clientJointHolder-precontractualInformation'
                )}${value.description} </a>`;
            }

            i++;
        });

        return checkBoxLabel;
    }

    handleSave(name, value) {
        const { userProfile } = this.props;
        let data = {};
        const showLoader = false;
        const accessToken = userProfile.accessToken;

        if (name) {
            data[name] = value;
        } else {
            data = value;
        }

        this.props.actions.savePersonalInformation(data, accessToken, showLoader, (saved, errors) => {
            if (!saved) {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_ENVIAR_DATOS_PERSONALES });
                }
            }
        });
    }

    formattedIban(iban) {
        let formattedIban;
        if (iban) {
            formattedIban = iban.split(' ').join('-');
        }

        return formattedIban;
    }

    buildPromoCode() {
        const { promotionalCode } = this.props;

        if (this.state.showPromoCode) {
            const promoCode = promotionalCode.get('promotionalCode');

            return (
                <AppliedPromoCode
                    title={promoCode.get('title')}
                    description={promoCode.get('details')}
                    img={promoCode.get('img')}
                />
            );
        }
    }

    getjointHolderType() {
        const { userProfile } = this.props;
        let holderType;

        switch (userProfile.jointHolderType) {
            case COOWNER:
                holderType = formatText('jointHolderAccountType-jointHolder1');
                break;
            case AUTHORIZED:
            case REPRESENTATIVE:
                holderType = formatText('jointHolderAccountType-authorized');
                break;
            default:
                break;
        }

        return holderType;
    }

    onhandleSubmit() {}

    cancelChanges() {
        this.setState({
            cancel: true,
        });
    }

    changeStyles(index) {
        this.setState({
            [index]: !this.state[index],
        });
    }

    render() {
        const { userProfile, userProfileForm, formActions, immStepsState, products } = this.props;
        //const items = [{ title: 'Teléfono móvil', content: userProfile.cellPhone }, { title: 'Email', content: userProfile.email }, { title: 'Domicilio', content: userProfile.address }];
        const clientTitle = formatText('clientJointHolder-title');
        const onHandleContinue = this.onHandleContinue;
        const checkBoxLabel = this.buildCheckboxLabel();
        const disabled = immStepsState.get('readOnlyForms') || immStepsState.getIn(['steps', 0, 'finished']);
        const formattedIban = this.formattedIban;
        const buildPromoCode = this.buildPromoCode();
        const product = products.get('productsDescription');
        const jointHolderType = this.getjointHolderType();
        const showOpenCredit = userProfile.promoCode === 'OPENCREDIT';
        const showDebitInfo = product.includes('Debit') && getIsCoOwner(userProfile.jointHolderType);
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        return (
            <div>
                <InformationCard
                    name={userProfile.name}
                    iban={formattedIban(userProfile.iban)}
                    product={product}
                    jointHolderType={jointHolderType}
                    mainHolderName={userProfile.mainHolderName}
                    showDebitInfo={showDebitInfo}
                    showOpenCredit={showOpenCredit}
                >
                    {buildPromoCode}
                </InformationCard>
                <div className="divider"></div>
                <div className="basic-layering">
                    <TitleBox title={clientTitle} titleModifier="--blue" container="--joint-holder" dash="dash-blue" />
                    <div className="prospects-gutter joint-holder__subtitle">
                        <FormattedText
                            value="clientJointHolder-subtitle"
                            injectedStrings={[PUBLICA_URL + mobileLoginToggleString]}
                        />
                        <InfoTooltip
                            text={<FormattedText value="clientJointHolder-tooltip" />}
                            addClass="joint-holder__subtitle--tooltip"
                        />
                    </div>
                    <ul className="items">
                        <ItemTelephone
                            title={'Teléfono móvil'}
                            content={userProfile.cellPhone}
                            changeStyles={this.changeStyles}
                            changeStylesState={this.state.changeStyles}
                            estilo={this.state.telefono ? '' : 'not-active'}
                        />
                        <ItemEmail
                            title={'Email'}
                            content={userProfile.email}
                            changeStyles={this.changeStyles}
                            changeStylesState={this.state.changeStyles}
                            estilo={this.state.email ? '' : 'not-active'}
                        />
                        <ItemAddress
                            title={'Domicilio de residencia'}
                            content={userProfile.address}
                            changeStyles={this.changeStyles}
                            changeStylesState={this.state.changeStyles}
                            estilo={this.state.domicilio ? '' : 'not-active'}
                        />
                    </ul>
                    <div className="prospects-gutter joint-holder-client">
                        <hr />
                        <div className="row">
                            <div className="col-sm-12 check-box__legal">
                                <CheckBox
                                    className="field_acceptClausule"
                                    profileModel="userProfile.clienteLegal"
                                    fieldsRequired="1"
                                    checkBoxList={[
                                        {
                                            label: (
                                                <FormattedText
                                                    value="clientJointHolder-legal"
                                                    injectedStrings={[checkBoxLabel]}
                                                />
                                            ),
                                            model: 'userProfile.clientAcceptTerms',
                                            onChange: function (e) {
                                                const status = e
                                                    ? { onSubmit: {} }
                                                    : { onSubmit: { disabled: 'disabled' } };
                                                this.setState(status);
                                                this.handleSave('legalAgree', e);
                                            }.bind(this),
                                        },
                                    ]}
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    remarkable={false}
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form__buttons form__footer">
                        <button
                            type="button"
                            className="form__button form__button-secondary"
                            onClick={onHandleContinue}
                            {...this.state.onSubmit}
                        >
                            <FormattedText value="button-start" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = ProfileStepClient1;
module.exports.ProfileStepClient1 = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        initialStep: state.initialStep,
        promotionalCode: state.promotionalCode,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        initialActions: bindActionCreators(initialActions, dispatch),
        promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(ProfileStepClient1);
